// extracted by mini-css-extract-plugin
export var chip = "_cv-0";
export var filterDropdown = "_cv-5";
export var filterItem = "_cv-6";
export var icon = "_cv-1";
export var removeButton = "_cv-3";
export var removeIcon = "_cv-4";
export var separator = "_cv-2";